module.exports = __webpack_public_path__ + "img/manufacturing-banner.917a7057.png";